//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';
import { useTheme } from '@mui/material/styles';

// === STYLE / MATERIAL UI ===
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { Logo    } from './Logo/Logo'       ;
import { NavBar  } from './NavBar/NavBar'   ;
import { UserNav } from './UserNav/UserNav' ;
import './menu.css';

//#endregion

//-----------------------------------------------------------------
export function Menu(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const background_theme = theme.palette.mode === 'light' ? 'primary' : 'secondary';

  const _styles = {
    bar: {
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
      boxShadow : '0 0 0.6em 0.01em' + theme.palette.primary.main,
      padding : '0.5rem' ,
      height  : '5rem' ,
      width   : '100%' ,
      display : 'flex' ,
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.bar} >
        <NavBar  />
        <Logo    />
        {props.children}
        <UserNav />
      </Box>
    )
  }

  //#endregion

  return display();
}
